import Vue from 'vue'
import App from './App.vue'
import VueResource from 'vue-resource';

import AppStartScreen from './components/StartScreen.vue';
import AppStepsScreen from './components/StepsScreen.vue';
import AppResultScreen from './components/ResultScreen.vue';

Vue.use(VueResource);

Vue.component('AppStartScreen', AppStartScreen);
Vue.component('AppStepsScreen', AppStepsScreen);
Vue.component('AppResultScreen', AppResultScreen);

// Корневой URL для всех запросов
Vue.http.options.root = '/requests/navigator/';

document.addEventListener("DOMContentLoaded", function() {
    let els = document.querySelectorAll('.step-form');
    Array.prototype.map.call(els, el => {
      new Vue({
        el: el,
        render: h => h(App)
      });
    });
});



// WEBPACK FOOTER //
// ./src/main.js